export const CREATE_ALERT = 'CREATE_ALERT';
export const CLEAR_ALERT = 'CLEAR_ALERT';
